import { InquirySuccessPage } from "~/features/inquirySuccess/components/InquirySuccessPage";

export function createStoreFinderConfirmationPage() {
  return <InquirySuccessPage />;
}
